
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer/[referralCode]/tracks/[trackId]",
      function () {
        return require("private-next-pages/refer/[referralCode]/tracks/[trackId]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer/[referralCode]/tracks/[trackId]"])
      });
    }
  